
























































































































































import { Action, State } from 'vuex-class';
import { cloneDeep } from 'lodash';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import UserMixin from '@/mixins/UserMixin';
import CustomSelect from '@/components/FormBuilder/CustomSelect.vue';
import FileLoader from '@/components/FileLoader.vue';
import FormFactoryModal from '@/components/Entity/FormFactoryModal.vue';
import DateRange from '@/components/common/DateRange.vue';
import LoadingDataMixin from '@/mixins/LoadingDataMixin';
import { Validations } from 'vuelidate-property-decorators';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { PlatformType, CostCentersType } from '@/store/directory/types';
import {
  Mixins,
  Component,
  Watch,
} from 'vue-property-decorator';
import { Attachment, CreatePretensionData } from '@/controllers/types';
import PretensionController from '@/controllers/Pretension';
import { EventEmitter } from 'events';

interface CashAccounts {
  client: any;
  costCenter: CostCentersType | null;
  amount: string | null;
}

interface FormData {
  type: string;
  date: string | null;
  supplier: any;
  platform: PlatformType | null;
  text: string;
  attachments: Attachment[];
  cashAccounts: CashAccounts[];
}

@Component({
  components: {
    CustomSelect,
    FormFactoryModal,
    DateRange,
    FileLoader,
  },
})
export default class CreatePretension extends Mixins(UserMixin, EntityHelperMixin, validationMixin, LoadingDataMixin) {
  isModalVisible = true;

  @State('platforms', { namespace: 'directory' })
  readonly platforms!: PlatformType[];

  @State('platformsIsLoading', { namespace: 'directory' })
  readonly platformsIsLoading!: boolean;

  uploadFiles = new EventEmitter();

  uploadFilesDone = true;

  clients = [];

  clientsIsLoading = false;

  suppliers = [];

  suppliersIsLoading = false;

  isSendingCreatingRequest = false;

  @State('costCenters', { namespace: 'directory' })
  readonly costCenters!: CostCentersType[];

  @State('costCentersIsLoading', { namespace: 'directory' })
  readonly costCentersIsLoading!: boolean;

  types = ['fine', 'damage'];

  defaultFormData: FormData = {
    type: '',
    date: null,
    supplier: null,
    platform: null,
    text: '',
    attachments: [],
    cashAccounts: [
      {
        client: null,
        costCenter: null,
        amount: null,
      },
    ],
  }

  formData: FormData = cloneDeep(this.defaultFormData);

  @Validations()
  validations = {
    formData: {
      type: {
        required,
      },
      date: {
        required,
      },
      supplier: {
        required,
      },
      platform: {
        required,
      },
      cashAccounts: {
        $each: {
          client: {
            required,
          },
          costCenter: {
            required,
          },
          amount: {
            required,
          },
        },
      },
    },
  }

  @Action('toggleEntityModal', { namespace: 'entity' })
  readonly toggleEntityModal: any;

  showModal() {
    this.toggleEntityModal(true);
  }

  closeModal() {
    this.toggleEntityModal(false);
  }

  filesChanged(files: Array<any>, uploadDone = false) {
    this.formData.attachments = files.map((v: any) => ({
      bucket: v.bucket,
      objectName: v.filename,
      type: 'attachment',
    }));
    this.uploadFilesDone = uploadDone;
  }

  addCashAccount() {
    this.formData.cashAccounts.push(cloneDeep(this.defaultFormData.cashAccounts[0]));
  }

  removeCashAccount(index: number) {
    this.formData.cashAccounts.splice(index, 1);
  }

  getValidationErrors(validations: any): string[] {
    const errors: string[] = [];
    if (!validations || validations.$error === false || validations.$invalid === false) {
      return errors;
    }
    if (validations.required === false) {
      errors.push('Обязательное поле');
    }
    return errors;
  }

  prepareBody(): CreatePretensionData {
    return {
      dateFrom: this.formData.date ? this.formData.date[0] : '',
      dateTo: this.formData.date ? this.formData.date[1] : '',
      platformId: String(this.formData.platform?.id),
      supplierId: String(this.formData.supplier.id),
      pretensionType: this.formData.type,
      expensesDescription: this.formData.text,
      justification: '',
      clients: this.formData.cashAccounts.map((item) => ({
        clientId: String(item.client.id),
        sapId: String(item.client.sap_id),
        costCenterId: String(item.costCenter?.id),
        costCenterName: String(item.costCenter?.name),
        sum: parseFloat(String(item.amount)),
      })),
      attachments: this.formData.attachments,
    };
  }

  async onSubmit() {
    const uploadFilesCallback = async () => {
      if (!this.uploadFilesDone) {
        this.$bus.$emit('notification', 'Не все файлы загружены', 'error');
        return;
      }

      try {
        this.isSendingCreatingRequest = true;
        const data = this.prepareBody();
        const response = await PretensionController.create(data);
        const [error, result] = response.result;
        if (error) {
          this.$bus.$emit('notification', `Возникла ошибка при выполнении операции, попробуйте позже - ${error}`, 'error');
          console.error(error);
          return;
        }

        console.log('Result after creating pretension - ', result);
        this.formData = cloneDeep(this.defaultFormData);
        this.$v.$reset();
        this.$bus.$emit('notification', 'Операция выполнена', 'success');
        this.closeModal();
        this.$emit('after-creation');
      } catch (error) {
        console.error(error);
        this.$bus.$emit('notification', `Возникла ошибка при выполнении операции, попробуйте позже - ${error}`, 'error');
      } finally {
        this.isSendingCreatingRequest = false;
      }
    };

    this.$v.$touch();
    if (this.$v.$invalid || this.$v.$error) {
      this.$bus.$emit('notification', 'Не все поля заполнены корректно', 'error');
      return;
    }
    this.uploadFiles.emit('upload', uploadFilesCallback);
  }

  clearSelectedClients() {
    this.formData.cashAccounts.forEach((item) => {
      item.client = this.defaultFormData.cashAccounts[0].client;
    });
  }

  @Watch('isModalVisible')
  onModalStateChange(value: boolean) {
    if (!value) {
      this.formData = this.defaultFormData;
      this.$v.$reset();
    }
  }

  @Watch('formData.platform', {
    immediate: true,
  })
  formDataPlatformChange() {
    this.formData.supplier = this.defaultFormData.supplier;
    this.loadDataByLike('suppliers', 'Supplier', 'PlantsHR', this.formData?.platform?.id || '', 'cache-first', {
      maxDepth: 1,
    });
    this.clearSelectedClients();
    this.loadDataByLike('clients', 'Client', 'Plants', this.formData?.platform?.id || '', 'cache-first', {
      maxDepth: 1,
    });
  }
}
